
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { useContacts } from "@/hooks/useContacts";
import { ContactForm } from "@/components/contact/ContactForm";

export default function CreateContact() {
  const navigate = useNavigate();
  const { createContact } = useContacts();
  const { toast } = useToast();
  const [searchParams] = useSearchParams();
  const preselectedOrgId = searchParams.get("organization");
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Prepare initial values if organization is preselected
  const initialValues = preselectedOrgId ? { organization_id: preselectedOrgId } : {};

  async function onSubmit(data: any) {
    try {
      setIsSubmitting(true);
      await createContact(data);
      toast({
        title: "Contact created",
        description: "The contact has been successfully created.",
      });
      
      // Redirect to the appropriate page after creation
      if (data.organization_id) {
        navigate(`/organizations/${data.organization_id}`);
      } else {
        navigate("/contacts");
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to create contact. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold tracking-tight">Create Contact</h1>
      </div>

      <ContactForm 
        initialValues={initialValues}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
}
